module.exports = __webpack_public_path__ + "img/23m.5276c023.png";